import { render, staticRenderFns } from "./EditorList.vue?vue&type=template&id=3a94928a&"
import script from "./EditorList.vue?vue&type=script&lang=js&"
export * from "./EditorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports